<template>
	<div>

		<div class="row-fluid">
			<div class="span12">
				<div id="demo" class="carousel slide" data-ride="carousel">
					<!-- 指示符 -->
					<ul class="carousel-indicators">
						<li data-target="#demo" data-slide-to="index" :class="{ active: index == 0 }"
							v-for="(item, index) in List_1" :key="index"></li>
					</ul>

					<!-- 轮播图片 -->
					<div class="carousel-inner">
						<div class="carousel-item" v-for="(item, index) in List_1" :key="index"
							:class="{ active: index == 0 }">
							<img class="center-block carousel-item-img" :src="item.picture_src_a" />
						</div>
					</div>

					<!-- 左右切换按钮 -->
					<a class="carousel-control-prev" href="#demo" data-slide="prev">
						<span class="carousel-control-prev-icon"></span>
					</a>
					<a class="carousel-control-next" href="#demo" data-slide="next">
						<span class="carousel-control-next-icon"></span>
					</a>
				</div>
				<div style="height: 40px"></div>
			</div>



			<!--快捷导航-->
			<div class="span12" style="margin-top: 20px">
				<div class="row">
					<div class="col-3 text-center" v-for="(item, index) in List_2" :key="index">
						<span @click="$router.push({path: item.connect})">
							<img :src="item.imgages_b" style="width: 30px; height: 30px" />
							<p class="b_t_5">{{ item.title }}</p>
						</span>
					</div>
				</div>
			</div>

			<!--快捷导航-->
			<div class="span12 t_20 text-left" style="margin-top: 10px">
				<div v-for="(item, index) in List_3" :key="index"
					:style="{ backgroundImage: 'url(' + item.imgages_b + ')' }" class="jumbotron jumbotron_bb t_20"
					@click="$router.push({path: 'show_special', query: { id: item.id }, })"
					style="margin-top: 15px;background-size: 100%;">

					<h4 style="color: #fff; font-size: 15px;">{{ item.title }}</h4>
					<h5><span class="label label-primary label_50">{{item.bin_1}}</span>
						{{item.bin_2}}
					</h5>
					</h5>
				</div>
			</div>

			<!--最新活动-->
			<div class="span12 text-left">
				<div class="page-header">
					<div class="row">
						<div class="col-6">
							<h4>推荐内容</h4>
						</div>
						<div class="col-6 text-right" @click="$router.push('list_voice')">
							<h6 class="text-muted">
								<samp
									style=" color: #505153; background: #f3f4f8; border: 0; padding: 5px 8px 4px 10px;  border-radius: 15px; ">全部&nbsp;</samp>
							</h6>
						</div>
					</div>
				</div>

				<div style="margin-top: 20px;" class="jumbotron_c t_20" v-for="(item, index) in List_4" :key="index"
					@click="$router.push({path: item.connect})">
					<div class="row">
						<div class="col-3" style="padding-right: 0px">
							<div style="padding: 10px 0px 10px 10px">
								<img style="max-width: 70px; height: 70px" :src="item.imgages_1" v-if="item.imgages_1"
									title="暂无图片" />
								<div class="imgss" v-else>暂&nbsp;无<br />图&nbsp;片</div>
							</div>
						</div>
						<div class="col-9">
							<h5 class="h5_t_5">
								<span class="label label-primary label_50"
									style="padding-top: 4px">{{item.label}}</span>
								&nbsp;{{ item.title }}
							</h5>
							<footer class="blockquote-footer"
								style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
								{{ item.describe }}
							</footer>
							<h5 class="text-right" style="margin-bottom: 0px; padding-top: 3px">
								<span class="label label-primary-j1">详细信息</span>
							</h5>
						</div>
					</div>
				</div>





			</div>


			<div
				style="color: #666;width: 100%;height: 28px;text-algin: center;font-size: 10px;margin: 15px auto 10px;">
				<p style="margin-bottom: 3px; text-align: center; font-size: 10px">
					开发服务商：台州海盛网络
				</p>
				<p style="text-align: center; font-size: 10px">
					服务热线：<span style="color: #6b9ee6">0576-88888615</span>
				</p>
			</div>
			<div id="d_p"></div>


		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				List_1: [],
				List_2: [],
				List_3: [],
				List_4: [],
			};
		},
		mounted() {
			//默认加载token
			//this.getToken();
			//加载滚动图片
			this.getList_1();
		},
		methods: {
			getToken() {
				let t =
					"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjAxMSwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiIiLCJPcGVuaWQiOiIxMjMiLCJIZWFkaW1ndXJsIjoiIiwiQXV0aG9yaXR5S2V5IjowLCJBdXRob3JpdHlWYWx1ZSI6IkdVRVNUIiwiZXhwIjoxNjY5NDY0MDE3LCJpc3MiOiJoc25tcyIsIm5iZiI6MTYzNzkyNzAxN30.SLfpcDwuFBXoAcLMnzqvykxPPqy0YaTNZYoq325cYac";
				this.$api.setToken(t);
			},
			//加载数据列表类
			getList_1() {
				this.$api.getAPI("data/picture/?type_id=20201101").then((res) => {
					//加载按钮
					var d = res.data.data;
					this.List_1 = res.data.data.data[0].models;
					console.log(d.data[0].models);
					this.getList_2();
				});
			},
			//加载按钮内容
			getList_2() {
				this.$api.getAPI("data/navigation/?type_id=20201102").then((res) => {
					var d = res.data.data;
					this.List_2 = d.data[0].models;
					console.log(d.data[0].models);
					this.getList_3();
				});
			},
			//加载栏目内容
			getList_3() {
				this.$api.getAPI("data/page/?type_id=20201103").then((res) => {
					var d = res.data.data;
					this.List_3 = d.data[0].models;
					console.log(d.data[0].models);
					this.getList_4();
				});
			},
			//加载服务推荐
			getList_4() {
				this.$api.getAPI("data/info/?type_id=20201104").then((res) => {
					var d = res.data.data;
					this.List_4 = d.data[0].models;
					console.log(d.data[0].models);
				});
			},
			//
		},
	};
</script>


<style scoped>
	/* Make the image fully responsive */
	.carousel-inner img {
		width: 100%;
	}

	.btn-primary {
		color: #fff;
		background-color: #01b2c2;
		border-color: #01b2c2;
	}

	.imgss {
		text-align: center;
		width: 100%;
		height: 70px;
		font-size: 16px;
		line-height: 35px;
		border: 1px solid #c0c0c0;
	}

	.label_50 {
		border-radius: 50px/50px;
	}

	.page-header {
		margin: 25px 0 0px;
	}

	.h5_t_5 {
		margin-top: 15px;
	}

	.b_t_5 {
		padding-top: 6px;
	}

	.border_ {
		background: #002752;
	}

	.carousel-inner {
		border-bottom: 1px solid #000;
	}

	.carousel-indicators {
		bottom: -28px !important;
	}

	.carousel-indicators li {
		background-color: #000000;
	}

	.carousel-item-img {
		border-top-left-radius: 0.8em;
		border-top-right-radius: 0.8em;
		background-color: transparent;
		box-shadow: 0px 0px 8px 3px #fff;
	}

	.border {
		display: inline-block;
		width: 70px;
		height: 70px;
		margin: 6px;
	}

	.jumbotron {
		padding: 1rem 1rem;
		margin-bottom: 1rem;
	}

	.jumbotron_aa {
		width: 100%;
		height: 84px;
		padding: 10px 20px !important;
		/* background-image: url("../../assets/bj2.jpg") !important; */
		background-size: 100% 100%;
		background-position: center center;
		color: #fff;
	}

	.jumbotron_bb {
		width: 100%;
		height: 84px;
		padding: 10px 20px !important;
		/* background-image: url("../../assets/bj1.jpg") !important; */
		background-size: 100% 100%;
		background-position: center center;
		color: #fff;
		/* background: #3480fa; */
	}

	.jumbotron_c {
		background: #f3f4f8;
	}

	.carousel-indicators li {
		width: 6px;
		height: 6px;
		background-color: #77b2ff;
	}

	.carousel-indicators .active {
		background-color: #3b76fe;
		width: 30px;
		height: 7px;
	}

	.label-primary {
		color: #3480fa;
		background-color: #dcdfe6;
	}

	.label-primary-j {
		color: #fff;
		background-color: #3b76fe;
		border-radius: 15px 0px 0px 0px;
	}

	.label-primary-j1 {
		color: #fff;
		background-color: #91acbe;
		border-radius: 5px 0px 5px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/home_index.vue